export default class PageUtils {

  static I_DISPLAY_START_KEY = 'iDisplayStart';
  static I_DISPLAY_LENGTH_KEY = 'iDisplayLength';

  static pageSearch(current, size, search) {
    return {
      current: current,
      size: size,
      search: search
    };
  }

  static pageSearch2Old(pageSearch) {
    let old = {
      aoData: [{
        name: PageUtils.I_DISPLAY_START_KEY,
        value: (pageSearch.current - 1) * pageSearch.size
      }, {
        name: PageUtils.I_DISPLAY_LENGTH_KEY,
        value: pageSearch.size
      }]
    };
    let search = pageSearch.search;
    for (let key in search) {
      if (search.hasOwnProperty(key) && ['current', 'size', 'search'].indexOf(key) === -1) {
        old[key] = search[key];
      }
    }
    return old;
  }

  static old2PageSearch(old) {
    return PageUtils.pageSearch(old[PageUtils.I_DISPLAY_START_KEY] / old[PageUtils.I_DISPLAY_LENGTH_KEY] + 1,
        old[PageUtils.I_DISPLAY_LENGTH_KEY], old);
  }
}
